import { render, staticRenderFns } from "./WorkspaceSwitcher.vue?vue&type=template&id=56d83de3&scoped=true&"
import script from "./WorkspaceSwitcher.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSwitcher.vue?vue&type=style&index=0&id=56d83de3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d83de3",
  null
  
)

export default component.exports